import API from "api.js";
import { store } from "store";
import { setUser } from "action";

/**
 * Refreshes the logged-in user's subscription info in Redux so UI updates immediately
 * (sidebar, transaction page, gated routes, etc.).
 *
 * Source of truth: GET dashboard_data -> res.data.data.subscription
 */
export async function refreshUserSubscriptions(dispatch) {
  try {
    const res = await API({
      url: "dashboard_data",
      method: "GET",
      handlerEnabled: false,
    });

    const subscription = res?.data?.data?.subscription;
    if (!subscription) return null;

    const currentUser = store.getState().user || {};
    const updatedUser = { ...currentUser, active_subscription: subscription };
    dispatch(setUser(updatedUser));
    return subscription;
  } catch (e) {
    // non-fatal: we still want to show the success UI even if refresh fails
    return null;
  }
}

